export enum ScreenName {
    VOD_PLAYER = "VOD-Player",
    LIVE_TV_PLAYER = "LiveTV-Player",
    VCLOUD_PLAYER = "VCloud-Player",
    PROGRAM_DETAILS = "Program Details",
    VOD_MOVIE_DETAILS = "Movie Details",
    VOD_SERIES_DETAILS = "Series Details",
    HOME = "Home",
    VOD_CHANNELS = "VOD Channels",
    VOD_CHANNELS_PREMIUM = "VOD Channels Premium",
    VOD_GENRE = "VOD Genre Items",
    MY_TV_PAGE = "My TV",
    SEARCH_PAGE = "Search",
    SETTINGS_PAGE = "Settings",
    SPLASH_SCREEN = "Splash",
    WELCOME_PAGE = "Welcome Screen",
    LOGIN_PAGE = "Login",
    GUIDE_PAGE = "Guide",
    VOD_PAGE = "VOD",
};
